/** Dark loading placeholder for the student cohort detail page. */
export function StudentCohortDetailSkeleton() {
  return (
    <div
      className="student-cohort-details student-cohort-details--loading"
      aria-busy="true"
      aria-label="Loading cohort"
    >
      <div className="student-cohort-details-hero student-cohort-details-hero--loading">
        <div className="student-cohort-details-hero-inner">
          <div className="course-details-skeleton-breadcrumb">
            <div className="skeleton skeleton--line skeleton--line-sm" />
          </div>
          <div className="skeleton course-details-skeleton-title" />
          <div className="skeleton skeleton--line skeleton--line-lg course-details-skeleton-lede" />
          <div className="course-details-skeleton-stats">
            {[0, 1, 2].map((i) => (
              <div key={i} className="course-details-skeleton-stat">
                <div className="skeleton skeleton--line skeleton--line-sm" />
                <div className="skeleton course-details-skeleton-stat-value" />
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="student-cohort-details-section student-cohort-details-pad">
        <div className="skeleton skeleton--panel-title" />
        <div className="skeleton skeleton--line skeleton--line-md" style={{ maxWidth: "28rem" }} />
      </section>

      <section className="student-cohort-details-section student-cohort-details-pad">
        <div className="skeleton skeleton--panel-title" />
        <ol className="course-details-skeleton-lessons">
          {[0, 1, 2].map((i) => (
            <li key={i} className="course-details-skeleton-lesson">
              <div className="skeleton course-details-skeleton-lesson-num" />
              <div className="skeleton skeleton--lesson-icon skeleton--lesson-icon-sm" />
              <div className="course-details-skeleton-lesson-copy">
                <div className="skeleton skeleton--line skeleton--line-lg" />
                <div className="skeleton skeleton--line skeleton--line-sm" />
              </div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
